import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=0833a034&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
import style0 from "./Play.vue?vue&type=style&index=0&id=0833a034&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833a034",
  null
  
)

export default component.exports